const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    backgroundColor: "#f9f9f9",
  },
  card: {
    backgroundColor: "#ffffff",
    border: "2px solid #007bff",
    borderRadius: "10px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    padding: "20px",
    maxWidth: "500px",
    textAlign: "center",
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#007bff",
    marginBottom: "15px",
  },
  text: {
    fontSize: "16px",
    color: "#333333",
    lineHeight: "1.6",
  },
};

const FreeShippingDisplay = ({ freeThreshold }: { freeThreshold: number }) => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Free Shipping</h2>
        <p style={styles.text}>
          You can earn free shipping with a minimum purchase of ${freeThreshold}{" "}
          excluding donations.
        </p>
      </div>
    </div>
  );
};

export default FreeShippingDisplay;
